'use client';

import React from 'react';
import { motion } from 'framer-motion';
import { BadgeWithIcon } from '@/components/ui/BadgeWithIcon/BadgeWithIcon';

import styles from './OnlineServicesHeader.module.css';

export const OnlineServicesHeader = () => {
    return (
        <motion.div
            className={styles.headerWrapper}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
        >
            <motion.div
                className={styles.badgeContainer}
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
            >
                <BadgeWithIcon color="--color-green-rgb" icon="Apps" title="Онлайн-сервисы" />
            </motion.div>

            {/* Заголовок */}
            <h2 className={styles.title}>Онлайн-сервисы CDEK</h2>
            {/* Подзаголовок */}
            <p className={styles.subtitle}>Все инструменты для вашего бизнеса в одном месте</p>
        </motion.div>
    );
};
